import { chain } from 'icepick';
import isNil from 'lodash/isNil';
import queryString from 'query-string';
import type { Location } from '@atlassian/react-resource-router';
import { QUERY_PARAM_ISSUE_PARENT } from '../../../model/routing/constants';

// Check if the given issueId should be removed from issueParent queryparam based on given filters
export const removeIssueParentFromUrlByFilters = (
	location: Location,
	issueId: number | undefined,
	filters: string[] | undefined = [],
) => {
	const searchParams = queryString.parse(location.search);
	const updatedSearchParams = chain(searchParams);
	if (!isNil(searchParams[QUERY_PARAM_ISSUE_PARENT]) && !isNil(issueId)) {
		const urlIssueParents: string[] = searchParams[QUERY_PARAM_ISSUE_PARENT].split(',');

		// The closed issueId is in IssueParent QueryParams, but not in Filters , probably caused by deleting epics in detail view
		const issueIdStr = issueId.toString();
		if (urlIssueParents.includes(issueIdStr) && !filters.includes(issueIdStr)) {
			urlIssueParents.splice(urlIssueParents.indexOf(issueIdStr), 1);
		}

		urlIssueParents.length > 0
			? updatedSearchParams.set(QUERY_PARAM_ISSUE_PARENT, urlIssueParents.join(','))
			: updatedSearchParams.unset(QUERY_PARAM_ISSUE_PARENT);
	}
	return {
		...location,
		search: queryString.stringify(updatedSearchParams.value()),
	};
};
